import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Input } from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import{CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { 
  formatDate 
 } 
  from '@angular/common';
  

@Component({
  selector: 'app-member-info',
  standalone: true,
  imports: [MatDatepickerModule,MatInputModule,MatNativeDateModule,MatDateRangeInput,
            MatHint,MatLabel,MatFormFieldModule,CommonModule,FormsModule],
  templateUrl: './member-info.component.html',
  styleUrl: './member-info.component.css'
})
export class MemberInfoComponent implements OnInit {
  @Input() memberbasic:any;
  @Input() screentype:any;
  @Input() vital:any;
  @Input() conditions:any;
  @Input() deviceInfo:any;
  @Input() planStatus:any;
  @Output() onDatePicked = new EventEmitter<any>();
    currentDate:any = new Date();

    ngOnInit(): void {
      // Date picker is disabled; always use today's date for the API.
      this.onDatePicked.emit(formatDate(new Date(), 'yyyy-MM-dd', 'en-US'));
    }

    public extractByDate(date:HTMLInputElement){
     console.log(date.value);
     console.log(formatDate(date.value, 'yyyy-MM-dd','en-US'));
     this.onDatePicked.emit(formatDate(date.value, 'yyyy-MM-dd','en-US'));
  }

  formatTimestamp(timestamp: string): string {
    if (!timestamp) return '';
    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return timestamp;
      return formatDate(date, 'MMM d h:mm a', 'en-US');
    } catch (error) {
      return timestamp;
    }
  }
  shouldShowLabel(bmiData: any): boolean {
    return bmiData && bmiData.isMostRecentPreviousReading === true;
  }
  getDisplayLabel(bmiData: any): string {
    if (this.shouldShowLabel(bmiData) && bmiData.timestamp) {
      return `(As of ${this.formatTimestamp(bmiData.timestamp)})`;
    }
    return '';
  }

  get primaryDevice(): any {
    return this.deviceInfo?.devices?.length ? this.deviceInfo.devices[0] : null;
  }

  getPlatformIcon(): string {
    const deviceType = this.primaryDevice?.deviceType;
    if (!deviceType) return '';
    const type = deviceType.toLowerCase();
    if (type === 'android') return 'assets/img/memberdashboard/android.png';
    if (type === 'ios') return 'assets/img/memberdashboard/apple.png';
    return '';
  }

  getAppVersion(): string {
    const version = this.primaryDevice?.appVersion || '';
    const buildNumber = this.primaryDevice?.appBuildNumber;
    return buildNumber ? `${version}(${buildNumber})` : version;
  }

  getPlanStatusText(): string {
    const status = this.planStatus?.planStatus ?? this.planStatus;
    return status ? status : 'No Plan Found';
  }

  getGenderText(): string {
    const gender = this.memberbasic?.gender;
    if (!gender) return '---';
    return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
  }
}
